<template lang="pug">
    v-alert.width-100-percent.pr-0(v-if="validLlmAssessmentItem" :type="alertType" :icon="alertIcon" :color="alertColor" dense text border='left')
        v-row(
            align="center"
            no-gutters
            style="display: flex;"
        )
            v-col(style="flex-grow: 25;")
                div
                    strong(style="color: var(--volie-gray);")
                        | {{ llmAssessmentItem.friendly_llm_assessment_type }}: 
                    span(style="color: var(--volie-gray);")
                        | {{ llmAssessmentItem.summary }}
            v-col
                UserFeedback(
                    v-if="!hideUserFeedback"
                    :llm-assessment-item="llmAssessmentItem"
                    :user-feedback="llmAssessmentItem.user_feedback"
                    :show-snackbar="showSnackbar"
                )


</template>

<script lang="ts">
    import Vue from 'vue';

    // Components
    import UserFeedback from '@/components/scorecards/user_feedback.vue';

    export default Vue.extend({
        data() {
            return {}
        },
        methods: {
        },
        computed: {
            alertColor() {
                if (this.llmAssessmentItem.llm_assessment_type === 'summary' || this.llmAssessmentItem.llm_assessment_type === 'promise' || this.isEntityDetectionMatchDisposition) {
                    return 'var(--volie-gray)';
                } else if (this.llmAssessmentItem.is_flagged) {
                    return 'error';
                } else {
                    return 'success';
                }
            },
            alertIcon() {
                if (this.llmAssessmentItem.llm_assessment_type === 'summary' || this.llmAssessmentItem.llm_assessment_type === 'promise') {
                    return null;
                } else if (this.llmAssessmentItem.is_flagged) {
                    return 'mdi-flag-variant';
                } else {
                    return 'mdi-check-circle';
                }
            },
            alertType() {
                if (this.llmAssessmentItem.llm_assessment_type === 'summary' || this.llmAssessmentItem.llm_assessment_type === 'promise') {
                    return 'info';
                } else if (this.llmAssessmentItem.is_flagged) {
                    return 'error';
                } else {
                    return 'success';
                }
            },
            isEntityDetectionMatchDisposition(){
                if (this.llmAssessment?.EntityDetectionMatchId > 0 && this.llmAssessmentItem?.llm_assessment_item_type === 'disposition_match') {
                    return true
                }
                return false
            },
            validLlmAssessmentItem() {
                if (this.skipSummary && this.llmAssessmentItem?.llm_assessment_type === 'summary') {
                    return false;
                }

                return this.llmAssessmentItem?.friendly_llm_assessment_type?.length > 0 && this.llmAssessmentItem?.summary?.length > 0;
            },
        },
        components: {
            UserFeedback,
        },
        props: {
            hideUserFeedback: {
                type: Boolean,
                default: false,
                required: false,
            },
            llmAssessment: Object,
            llmAssessmentItem: Object,
            showSnackbar: Function,
            skipSummary: Boolean,
        },
        created() {
        },
    });
</script>

<style lang="scss" scoped>
    #app {

    }
</style>
